<template>
    <div>
      <el-dialog
        title="编辑"
        :visible="dialogShow"
        width="30%"
        @open="init"
        @close="handleDialog"
        :close-on-click-modal="false"
      >
        <div>
          <div style="font-size: 16px; display: flex">
            <i
              class="el-icon-info"
              style="color: #e6a23c; font-size: 22px; margin-right: 6px"
            ></i
            >修改代理手续费
          </div>
          <p>
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item
                label="代理代收利润"
                prop="paymentAgentFee"
              >
                <el-input
                  v-model="form.paymentAgentFee"
                  type="text"
                  size="small"
                  style="width: 300px"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="代理代付利润"
                prop="transferAgentFee"
              >
                <el-input
                  v-model="form.transferAgentFee"
                  type="text"
                  size="small"
                  style="width: 300px"
                ></el-input>
              </el-form-item>


              <el-form-item label="备注" prop="updateRemark">
                <el-input
                  type="textarea"
                  placeholder="请输入备注"
                  v-model="form.updateRemark"
                  style="width: 90%"
                ></el-input>
              </el-form-item>


            </el-form>
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialog">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  export default {
    props: {
      show: Boolean,
      formData: Object,
      action: String,
    },
    data() {
      return {
        dialogShow: this.show,
        form: {
          settlementId: '',
          paymentAgentFee: '',
          transferAgentFee: '',
          updateRemark: '',
        },
        rules: {
          updateRemark: [
            { required: true, message: '请输入备注', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      init() {
        this.form.settlementId=this.formData.settlementId,
        this.form.paymentAgentFee=this.$formatter.FenToYuan(
          null,
          null,
          this.formData.paymentAgentFee,
          null
        ),
        this.form.transferAgentFee=this.$formatter.FenToYuan(
          null,
          null,
          this.formData.transferAgentFee,
          null
        ),
        this.form.updateRemark=this.formData.updateRemark
      },
      handleDialog() {
        this.form = {
          settlementId: '',
          paymentAgentFee: '',
          transferAgentFee: '',
          updateRemark: '',
        }
        this.$refs['form'].resetFields()
        this.$emit('update:show', false)
      },
      submit() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            let params = {
              ...this.form,
            }
            this.$axios
              .post('/agentSettlement/updateAgentSettlement', params)
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: '提示',
                    message: res.msg,
                    type: 'success',
                  })
                  this.$emit('update:show', false)
                  this.$bus.$emit('refresh') //通知刷新
                } else {
                  this.$notify.error({
                    title: '提示',
                    message: res.msg,
                  })
                }
              })
          }
        })
      },
    },
    watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #e4e7ed;
  }
  </style>